import longMosqueImage from '../assets/long-mosque.png';

const MosqueVision = () => {
    return (
        <section className="bg-white">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-24">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
                    {/* Image Column */}
                    <div className="relative h-[60vh] lg:h-[80vh] w-full group overflow-hidden">
                        <img 
                            src={longMosqueImage} 
                            alt="Mosque Vision" 
                            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                        />
                        <div className="absolute inset-0 bg-black/20"></div>
                        
                        {/* Overlay text on image */}
                        <div className="absolute bottom-10 left-10 right-10">
                            <h2 className="text-3xl md:text-5xl font-serif text-white mb-4 leading-tight drop-shadow-md">
                                Building Unity,<br/>One Brick at a Time
                            </h2>
                            <div className="w-12 h-0.5 bg-white mb-4"></div>
                        </div>
                    </div>

                    {/* Text Column */}
                    <div className="space-y-8">
                        <div>
                            <h3 className="text-2xl font-serif text-brand-green mb-6 leading-relaxed">
                                This is how you can help your brothers and sisters out around the world.
                            </h3>
                            <p className="text-gray-600 font-sans leading-relaxed mb-6">
                                It all started with a simple idea: to use social media as a way to inspire change, share reminders, and create unity among Muslims. <span className="italic">Alhamdulillah</span>, what began as short posts and small efforts quickly grew into a community of brothers and sisters who were eager for guidance, purpose, and belonging.
                            </p>
                            <p className="text-gray-600 font-sans leading-relaxed mb-8">
                                But through these interactions, I realized something deeper: online content can touch hearts, but what our Ummah truly needs is a physical hub. A place where Muslims, especially the younger generation in Canada and the West, can come together, pray together, learn together, and grow together.
                            </p>
                            
                            <ul className="space-y-4 mb-8">
                                <li className="flex items-start">
                                    <span className="w-1.5 h-1.5 mt-2.5 rounded-full bg-brand-green mr-4 flex-shrink-0"></span>
                                    <span className="text-gray-700 font-sans">A place that is more than bricks and walls.</span>
                                </li>
                                <li className="flex items-start">
                                    <span className="w-1.5 h-1.5 mt-2.5 rounded-full bg-brand-green mr-4 flex-shrink-0"></span>
                                    <span className="text-gray-700 font-sans">A centre where future generations are nurtured in Qur'an and Sunnah, ready to lead with faith, unity, and strength.</span>
                                </li>
                                <li className="flex items-start">
                                    <span className="w-1.5 h-1.5 mt-2.5 rounded-full bg-brand-green mr-4 flex-shrink-0"></span>
                                    <span className="text-gray-700 font-sans">A place that connects Muslims not only in Canada, but across the world, under one vision of unity and service to Allah ﷻ.</span>
                                </li>
                            </ul>
                        </div>

                        {/* Highlight Box */}
                        <div className="bg-brand-cream border-l-2 border-brand-green p-8">
                            <p className="font-serif italic text-lg text-gray-800 leading-relaxed mb-4">
                                This is why we are building this mosque. It is not just a prayer space. It is a center for unity,
                                education, and community-building. By supporting this project, you are helping create a legacy of
                                guidance, strength, and brotherhood for decades to come.
                            </p>
                            <div className="pt-4 border-t border-gray-200">
                                <p className="text-sm font-sans text-gray-500">
                                    <strong className="text-brand-green uppercase tracking-wider text-xs">Note:</strong> This is the vision we are trying to go after, although in the worst case scenario,
                                    all proceeds will go to a mosque that we believe shares a similar vision <span className="italic">insha'Allah</span>.
                                </p>
                            </div>
                        </div>

                        {/* Hadith Quote */}
                        <div className="text-center py-6">
                            <p className="text-xl font-serif text-gray-800 mb-2">
                                "Whoever builds a mosque for Allah, Allah will build for him a house in Jannah."
                            </p>
                            <p className="text-xs font-sans tracking-widest uppercase text-gray-500">
                                (Bukhari & Muslim)
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MosqueVision;